import { ActionsButtonItem } from '../../../../ui/components/pure/actions-button/actions-button.types';
import { UserDto, KnownUserStatus, KnownUserDtoUserType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { makeDefineActions } from '../../../../ui/components/pure/actions-button/actions-button.helpers';
import { Edit } from '../../../../ui/components/pure/icons/Edit.icon';
import { Enable } from '../../../../ui/components/pure/icons/Enable.icon';
import { Suspend } from '../../../../ui/components/pure/icons/Suspend.icon';
import { Permissions } from '../../../../core/permissions/permissions.typings';

export enum UserDetailsActions {
  EDIT_GROUP_MEMBER = 'EDIT_GROUP_MEMBER',
  EDIT_GROUP_MEMBER_SUCCESS = 'EDIT_GROUP_MEMBER_SUCCESS',
  EDIT_CAPABILITIES = 'EDIT_CAPABILITIES',
  EDIT_CAPABILITIES_SUCCESS = 'EDIT_CAPABILITIES_SUCCESS',
  ACTIVATE_GROUP_MEMBER = 'ACTIVATE_GROUP_MEMBER',
  DEACTIVATE_GROUP_MEMBER = 'DEACTIVATE_GROUP_MEMBER',
  STATUS_CHANGE_SUCCESS = 'STATUS_CHANGE_SUCCESS',
  STATUS_CHANGE_ERROR = 'STATUS_CHANGE_ERROR',
  ADD_NOTE = 'ADD_NOTE',
  ADD_NOTE_SUCCESS = 'ADD_NOTE_SUCCESS'
}

function makeUserDetailsActions(
  userType: KnownUserDtoUserType,
  projectID: string
): ActionsButtonItem<UserDetailsActions>[] {
  return [
    {
      title: `Edit ${userType}`,
      Icon: Edit,
      action: UserDetailsActions.EDIT_GROUP_MEMBER,
      permission: {
        action: Permissions.users.update,
        projectID
      }
    },
    {
      title: `Edit capabilities`,
      Icon: Edit,
      action: UserDetailsActions.EDIT_CAPABILITIES,
      permission: {
        action: Permissions.users.update,
        projectID
      },
      availableUiFeatures: ['internal-groundfloor']
    },
    {
      title: 'Reactivate',
      Icon: Enable,
      action: UserDetailsActions.ACTIVATE_GROUP_MEMBER,
      permission: {
        action: Permissions.users.update,
        projectID
      }
    },
    {
      title: 'Deactivate',
      Icon: Suspend,
      action: UserDetailsActions.DEACTIVATE_GROUP_MEMBER,
      permission: {
        action: Permissions.users.update,
        projectID
      }
    }
  ];
}

function makeValidateAction(user: UserDto) {
  return function validateAction(action: UserDetailsActions) {
    switch (action) {
      case UserDetailsActions.DEACTIVATE_GROUP_MEMBER:
        switch (user.status) {
          case KnownUserStatus.Active:
            return true;
          default:
            return false;
        }
      case UserDetailsActions.ACTIVATE_GROUP_MEMBER:
        switch (user.status) {
          case KnownUserStatus.Inactive:
            return true;
          default:
            return false;
        }
      default:
        return true;
    }
  };
}

export function makeDefineUserDetailsActions(userType: KnownUserDtoUserType, user: UserDto) {
  return makeDefineActions(makeUserDetailsActions(userType, user.projectId), undefined, makeValidateAction(user));
}
